import { render, staticRenderFns } from "./ShowTopicBoardModel.vue?vue&type=template&id=252c06c3&"
import script from "./ShowTopicBoardModel.vue?vue&type=script&lang=js&"
export * from "./ShowTopicBoardModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports